import {  AnimatePresence } from 'framer-motion';
import { ChevronUp, ShieldCheck, Truck, CreditCard, Settings, } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const FAQPage = () => {
  const [openCategory, setOpenCategory] = useState<number | null>(null);
  const [openQuestion, setOpenQuestion] = useState<string | null>(null);

  const faqCategories = [
    {
      title: "Calidad de Productos",
      icon: <ShieldCheck className="w-6 h-6" />,
      questions: [
        {
          question: "¿Qué certificaciones tienen sus equipos médicos?",
          answer: "Contamos con certificaciones ISO 13485, CE Mark y FDA Clase II para todos nuestros dispositivos."
        },
        {
          question: "¿Realizan controles de calidad post-venta?",
          answer: "Sí, realizamos revisiones periódicas y mantenimiento preventivo incluido en la garantía."
        },
        {
          question: "¿Qué garantías ofrecen?",
          answer: "Garantía de 3 años para equipos electrónicos y 5 años para instrumentos quirúrgicos."
        }
      ]
    },
    {
      title: "Compras y Pagos",
      icon: <CreditCard className="w-6 h-6" />,
      questions: [
        {
          question: "¿Qué métodos de pago están disponibles?",
          answer: "Aceptamos tarjetas de crédito, transferencias bancarias y financiamiento institucional."
        },
        {
          question: "¿Ofrecen facturación electrónica?",
          answer: "Sí, emitimos facturas electrónicas con validez fiscal según normativa DGII."
        },
        {
          question: "¿Tienen descuentos por volumen?",
          answer: "Ofrecemos planes especiales para compras institucionales y pedidos recurrentes."
        }
      ]
    },
    {
      title: "Soporte Técnico",
      icon: <Settings className="w-6 h-6" />,
      questions: [
        {
          question: "¿Qué cobertura tiene el soporte técnico?",
          answer: "Soporte 24/7 con tiempos de respuesta de 2 horas para emergencias críticas."
        },
        {
          question: "¿Ofrecen capacitación en el uso de equipos?",
          answer: "Incluimos capacitación certificada para operación y mantenimiento básico."
        },
        {
          question: "¿Realizan actualizaciones de software?",
          answer: "Actualizaciones gratuitas durante el período de garantía con mantenimiento preventivo."
        }
      ]
    },
    {
      title: "Logística y Envíos",
      icon: <Truck className="w-6 h-6" />,
      questions: [
        {
          question: "¿Cuáles son los tiempos de entrega?",
          answer: "Entrega estándar 3-5 días hábiles, servicio express disponible en 24 horas."
        },
        {
          question: "¿Hacen envíos internacionales?",
          answer: "Sí, realizamos exportaciones a toda Latinoamérica con documentación aduanal incluida."
        },
        {
          question: "¿Cómo rastreo mi pedido?",
          answer: "Proporcionamos código de seguimiento y monitoreo en tiempo real vía SMS/email."
        }
      ]
    }
  ];


  return (
    <div className="min-h-screen bg-main-bg">
      <header className="bg-gradient-to-r from-primary to-dark text-main-bg py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 
           
            className="text-4xl md:text-5xl font-poppins font-bold mb-4"
          >
            Centro de Ayuda
          </h1>
          <p className="text-lg font-montserrat max-w-3xl mx-auto">
            Respuestas técnicas especializadas para equipos médicos profesionales
          </p>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-16">
        <div 
          
          className="space-y-6"
        >
          {faqCategories.map((category, index) => (
            <div 
              key={index}
             
              className="bg-section-bg rounded-xl shadow-sm"
            >
              <button
                onClick={() => setOpenCategory(openCategory === index ? null : index)}
                className="w-full flex items-center justify-between p-6"
              >
                <div className="flex items-center gap-4">
                  <div className="bg-primary p-3 rounded-lg text-main-bg">
                    {category.icon}
                  </div>
                  <h3 className="text-1xl md:text-xl font-poppins font-semibold text-dark">
                    {category.title}
                  </h3>
                </div>
                <div
                 
                >
                  <ChevronUp className="w-6 h-6 text-dark" />
                </div>
              </button>

              <AnimatePresence>
                {openCategory === index && (
                  <div
                   
                    className="overflow-hidden"
                  >
                    <div className="p-6 pt-0 space-y-4">
                      {category.questions.map((question, qIndex) => (
                        <div key={qIndex} className="border-t border-primary/20 pt-4">
                          <button
                            onClick={() => setOpenQuestion(openQuestion === `${index}-${qIndex}` ? null : `${index}-${qIndex}`)}
                            className="w-full flex justify-between items-start gap-4"
                          >
                            <h4 className="text-lg font-poppins font-medium text-dark text-left flex-1">
                              {question.question}
                            </h4>
                            <div
                            
                            >
                              <ChevronUp className="w-5 h-5 text-primary" />
                            </div>
                          </button>
                          <AnimatePresence>
                            {openQuestion === `${index}-${qIndex}` && (
                              <div
                                className="text-gray-600 font-montserrat pt-2"
                              >
                                {question.answer}
                              </div>
                            )}
                          </AnimatePresence>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div 
          className="mt-16 p-3 bg-accent text-main-bg rounded-xl text-center"
          
        >
          <Settings className="w-12 h-12 mx-auto mb-6" />
          <h2 className="text-2xl font-poppins font-bold mb-4">
            ¿Necesitas asistencia inmediata?
          </h2>
          <p className="font-montserrat mb-8 max-w-2xl mx-auto">
            Nuestro equipo de ingenieros biomédicos está disponible 24/7 para emergencias
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-block bg-main-bg text-accent py-3 px-8 rounded-lg font-poppins font-semibold hover:bg-primary hover:text-main-bg transition-colors"
            >
              Soporte Urgente
            </Link>
           
          </div>
        </div>
      </main>
    </div>
  );
};

export default FAQPage;